import { render } from "./medicalhistory.vue?vue&type=template&id=eeefe2ac&scoped=true"
import script from "./medicalhistory.js?vue&type=script&lang=js"
export * from "./medicalhistory.js?vue&type=script&lang=js"

import "./medicalhistory.vue?vue&type=style&index=0&id=eeefe2ac&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeefe2ac"]])

export default __exports__